import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Action } from "../../internal/Action.js";
import { QualifierValue } from "../../internal/qualifier/QualifierValue.js";
import { Qualifier } from "../../internal/qualifier/Qualifier.js";
/**
 * @description Defines how to improve an image by automatically adjusting image colors, contrast and brightness.</br>
 * <b>Learn more:</b> {@link https://cloudinary.com/documentation/image_transformations#image_improvement_effects|Image improvement effects}
 * @memberOf Actions.Adjust
 */

var ImproveAction = /*#__PURE__*/function (_Action) {
  _inherits(ImproveAction, _Action);

  var _super = _createSuper(ImproveAction);

  function ImproveAction() {
    var _this;

    _classCallCheck(this, ImproveAction);

    _this = _super.call(this);
    _this._actionModel = {
      actionType: 'improve'
    };
    return _this;
  }
  /**
   *
   * @description The improve mode.
   * @param {Qualifiers.ImproveMode | string} value
   */


  _createClass(ImproveAction, [{
    key: "mode",
    value: function mode(value) {
      this.modeValue = value;
      this._actionModel.mode = value;
      return this;
    }
    /**
     * @description How much to blend the improved result with the original image, where 0 means only use the original and 100 means only use the improved result. (Range: 0 to 100, Server default: 100)
     * @param {number} value
     */

  }, {
    key: "blend",
    value: function blend(value) {
      this.blendValue = value;
      this._actionModel.blend = value;
      return this;
    }
  }, {
    key: "prepareQualifiers",
    value: function prepareQualifiers() {
      var qualifierValue = new QualifierValue(['improve', this.modeValue, this.blendValue]).setDelimiter(':');
      this.addQualifier(new Qualifier('e', qualifierValue));
      return this;
    }
  }], [{
    key: "fromJson",
    value: function fromJson(actionModel) {
      var mode = actionModel.mode,
          blend = actionModel.blend; // We are using this() to allow inheriting classes to use super.fromJson.apply(this, [actionModel])
      // This allows the inheriting classes to determine the class to be created

      var result = new this();
      mode && result.mode(mode);
      blend && result.blend(blend);
      return result;
    }
  }]);

  return ImproveAction;
}(Action);

export { ImproveAction };